<template>
  <div class="languages">
    <select
      class="language-select"
      @change="switchLocale"
      v-model="this.$i18n.locale"
    >
      <option v-for="(locale, key) in locales" :key="key" :value="locale.code">
        {{ locale.label }}
      </option>
    </select>
  </div>
</template>

<script>
import Utils from "@/utils/Utils";

export default {
  name: "LocaleSwitcher",
  data() {
    return {
      locales:
        import.meta.env.VITE_GAR == "true"
          ? this.$store.getters["locales/getGarLocales"]
          : this.$store.getters["locales/getLocales"],
    };
  },
  watch: {
    selectedLocale(newValue) {
      this.$i18n.locale = newValue;
      Utils.setCookie("user-language", newValue, 36521);
      if (this.$store.getters["users/isLogged"]) {
        this.$store.dispatch("users/updateLocale");
      }
    },
  },
  computed: {
    selectedLocale() {
      return this.$i18n.locale;
    },
  },
};
</script>

<style scoped>
.language-select {
  background-color: transparent;
  border: none;
}
li {
  text-decoration: underline;
  color: #459ce7;
  cursor: pointer;
}
</style>
